<template>
    <el-dialog
        width="30%"
        :title="projectInfo && projectInfo.id ? '我要同款' : '提交需求'"
        :visible.sync="showRequestForm"
        @close="handleClickClose">
        <el-form :model="form" :rules="formRule" ref="form" label-width="80px">
            <el-form-item v-if="projectInfo && projectInfo.id" label="意向案例">
                <el-input v-model="projectInfo.title" readonly></el-input>
            </el-form-item>
            <el-form-item label="称呼" prop="name">
                <el-input v-model="form.name" placeholder="我们如何称呼您"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
                <el-input v-model="form.phone" placeholder="方便我们尽快联系您"></el-input>
            </el-form-item>
            <el-form-item label="行业需求" class="item-block" prop="content">
                <el-input v-model="form.content" type="textarea" :rows="4" placeholder="请告诉我们您的行业属性，需求，周期等信息，我们会在三个工作日内联系您"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="handleClickClose">取消</el-button>
            <el-button size="mini" type="primary" @click="handleClickSubmit">发送</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { submitNewRequest } from '@/api/projectCase';
    export default {
        name: 'RequestForm',
        props: {
            projectInfo: {
                type: [Object, null],
                required: false,
                default: () => null,
            },
            showRequestForm: {
                type: Boolean,
                required: true,
            }
        },
        data: () => ({
            form: {},
            formRule: {
                name: [
                    { required: true, message: '请输入您的姓名', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入您的电话号码', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '电话号码格式不正确，请检查确认', trigger: ['blur', 'change'] }
                ],
                // content: [
                //     { required: true, message: '请填写您的详细需求', trigger: 'blur' }
                // ],
            }
        }),
        mounted() {
        },
        methods: {
            /**
             * 点击提交需求
             */
            handleClickSubmit() {
                this.$refs.form.validate().then(() => {
                    submitNewRequest({
                        ...this.form,
                        projectId: this.projectInfo && this.projectInfo.id
                    }).then(() => {
                        this.$message.success('提交成功');
                        this.handleClickClose();
                    }).catch(() => {
                        this.$message.error('提交失败');
                    });
                });
            },
            /**
             * 关闭form表单
             */
            handleClickClose() {
                this.$emit('update:showRequestForm', false);
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>
